// import { Link } from "react-router-dom";
// import { useState } from "react";
// import PopCH from "../../popUp/popCM";
// import PopSp from "../../popUp/popSP";
// import PopUpDrop from "../../popUp/popUpDrop";
// import PopUpLibr from "../../popUp/popUpLibr";
// import PopUpSuport from "../../popUp/popUpSuport";

// export default function FooterCenter({ scrollHeight }) {
//   const [popupPosition, setPopupPosition] = useState("");

//   const [popUp, setPopUp] = useState(false);
//   const handleMouseEnter = () => {
//     setPopUp(true);
//   };

//   const handleMouseLeave = () => {
//     setPopUp(false);
//   };
//   const [popUpKlas, setPopUpKlas] = useState(false);
//   const handleMouseEnterKlas = () => {
//     setPopUpKlas(true);
//   };

//   const handleMouseLeaveKlas = () => {
//     setPopUpKlas(false);
//   };
//   const [popUpDrop, setPopUpDrop] = useState(false);
//   const dropFunc = () => {
//     setPopUpDrop(!popUpDrop);
//   };
//   const [popUpLibr, setPopUpLibr] = useState(false);
//   const handleMouseEnterLibr = () => {
//     setPopUpLibr(true);
//   };

//   const handleMouseLeaveLibr = () => {
//     setPopUpLibr(false);
//   };
//   const [popUpSuport, setPopUpSuport] = useState(false);
//   const handleMouseEnterSuport = () => {
//     setPopUpSuport(true);
//   };

//   const handleMouseLeaveSuport = () => {
//     setPopUpSuport(false);
//   };
//   const calculatePopupPosition = () => {
//     // Отримайте позицію кнопки
//     const buttonPosition = document
//       .querySelector(".whoyIsOpRada")
//       .getBoundingClientRect();

//     // Отримайте розміри попапу
//     const popupHeight = 250; // Задайте висоту попапу (можете змінити за необхідністю)
//     setPopupPosition(buttonPosition.top);
//     // Обчисліть вертикальну позицію попапу
//     const topPosition = buttonPosition.top - popupHeight;
//     const element = document.querySelector(".musicWrapOp");

//     let needHeight = popupPosition + scrollHeight;
//     if (element) {
//       element.style.top = scrollHeight;
//     }
//   };
//   return (
//     <div className="footerWrapperCenter">
//       <div className="wrapCenterFirst">
//         <ul className="centerFirstUlF">
//           <li className="centerFirstLi">
//             <Link to="/about" className="centerFirstLi">
//               Про видавництво
//             </Link>{" "}
//           </li>
//           <li className="centerFirstLi">
//             <Link to="/about" className="centerFirstLi">
//               Контакти
//             </Link>
//           </li>
//           <li className="centerFirstLi">
//             <Link to="/delivery" className="centerFirstLi">
//               Доставка
//             </Link>
//           </li>
//           <li className="centerFirstLi">
//             <Link to="/delivery" className="centerFirstLi">
//               Самовивіз
//             </Link>
//           </li>
//           <li
//             className="centerFirstLi"
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           >
//             Клуб Майстрів
//           </li>
//           {popUp && <PopCH />}
//         </ul>
//         <ul className="centerFirstUlS">
//           <li className="centerFirstLi">
//             <Link to="/delivery" className="centerFirstLi">
//               Де пощупати наші книги
//             </Link>
//           </li>
//           <li className="centerFirstLi">
//             <Link to="/publicOffer" className="centerFirstLi">
//               Публічна оферта
//             </Link>
//           </li>
//           {/* <li className="centerFirstLi">
//             <Link to="/delivery" className="centerFirstLi">
//               Книги ЧМ на АМАЗОН
//             </Link>
//           </li> */}
//           <li className="centerFirstLi">
//             <a
//               className="centerFirstLi"
//               target="_blanck"
//               href="https://knowhowbook.eu/"
//             >
//               {" "}
//               Книги ЧМ в Європі
//             </a>
//           </li>
//         </ul>
//       </div>
//       <div className="wrapCenterSecond">
//         <ul className="centerSecondUlSF">
//           <li className="centerSecondLi">
//             <Link
//               className="centerSecondLi"
//               to="mailto:zoryana@chasmaistriv.com.ua"
//             >
//               Ви хочете стати нашим партнером, замовте договір
//             </Link>
//           </li>
//           <li className="centerSecondLi">
//             <Link to="/opt" className="centerSecondLi">
//               Гуртове замовлення робити зручно
//             </Link>
//           </li>
//           <li
//             className="centerSecondLi"
//             onMouseEnter={handleMouseEnterKlas}
//             onMouseLeave={handleMouseLeaveKlas}
//           >
//             СП/ Корпоротивні/ на групу/ на клас
//           </li>
//           {popUpKlas && <PopSp />}
//         </ul>

//         <ul className="centerSecondUlS">
//           <li className="centerSecondLi" onClick={dropFunc}>
//             Дропшипінг
//           </li>
//           <li className="centerSecondLi">
//             <a
//               className="centerSecondLi"
//               href="https://drive.google.com/file/d/1oeD2FqWAzfLlQcIMIm7hPtSHOs2br-Dv/view?usp=sharing"
//               target="_blanck"
//             >
//               Каталог
//             </a>
//           </li>
//           <li className="centerSecondLi">
//             <a
//               className="centerSecondLi"
//               href="https://docs.google.com/spreadsheets/d/1K4ZJJXsdFtRWL5a14AtTMyWe-YMpnsxTXOJjLO8YHIw/edit#gid=1616448480"
//               target="_blanck"
//             >
//               Завантажити прайс
//             </a>
//           </li>
//           <li
//             className="centerSecondLi"
//             onMouseEnter={handleMouseEnterLibr}
//             onMouseLeave={handleMouseLeaveLibr}
//           >
//             Підтримка бібліотек і бібліотекарів
//           </li>
//           <li
//             className="centerSecondLi"
//             onMouseEnter={handleMouseEnterSuport}
//             onMouseLeave={handleMouseLeaveSuport}
//           >
//             Підтримка продавців-консультантів
//           </li>
//           {popUpDrop && <PopUpDrop />}
//           {popUpLibr && <PopUpLibr />}
//           {popUpSuport && <PopUpSuport />}
//         </ul>
//       </div>
//     </div>
//   );
// }
import { Link } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import PopCH from "../../popUp/popCM";
import PopSp from "../../popUp/popSP";
import PopUpDrop from "../../popUp/popUpDrop";
import PopUpLibr from "../../popUp/popUpLibr";
import PopUpSuport from "../../popUp/popUpSuport";
import PopUpEur from "../../popUp/popUpEur";
import FooterDynamicLinks from "../../admin/FooterCenter/FooterDynamicLinks";
export default function FooterCenter({ scrollHeight }) {
  const [popupPosition, setPopupPosition] = useState("");
  const [popUp, setPopUp] = useState(false);
  const [popUpKlas, setPopUpKlas] = useState(false);
  const [popUpDrop, setPopUpDrop] = useState(false);
  const [popUpLibr, setPopUpLibr] = useState(false);
  const [popUpSuport, setPopUpSuport] = useState(false);
  const [popUpEur, setPopUpEur] = useState(false);
  const eurRef = useRef(null);
  const dropRef = useRef(null);
  const cmRef = useRef(null);
  const klasRef = useRef(null);
  const librRef = useRef(null);
  const suportRef = useRef(null);

  const handleSuportClick = () => {
    setPopUpSuport((prev) => !prev);
  };

  const handleClickOutsideSuport = (event) => {
    if (
      suportRef.current &&
      !suportRef.current.contains(event.target) &&
      !event.target.closest(".centerSecondLi")
    ) {
      setPopUpSuport(false);
    }
  };

  useEffect(() => {
    if (popUpSuport) {
      document.addEventListener("mousedown", handleClickOutsideSuport);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideSuport);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSuport);
    };
  }, [popUpSuport]);

  const handleLibrClick = () => {
    setPopUpLibr((prev) => !prev);
  };

  const handleClickOutsideLibr = (event) => {
    if (
      librRef.current &&
      !librRef.current.contains(event.target) &&
      !event.target.closest(".centerSecondLi")
    ) {
      setPopUpLibr(false);
    }
  };
  useEffect(() => {
    if (popUpLibr) {
      document.addEventListener("mousedown", handleClickOutsideLibr);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideLibr);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideLibr);
    };
  }, [popUpLibr]);

  const handleKlasClick = () => {
    setPopUpKlas((prev) => !prev);
  };

  const handleClickOutsideKlas = (event) => {
    if (
      klasRef.current &&
      !klasRef.current.contains(event.target) &&
      !event.target.closest(".centerSecondLi")
    ) {
      setPopUpKlas(false);
    }
  };
  useEffect(() => {
    if (popUpKlas) {
      document.addEventListener("mousedown", handleClickOutsideKlas);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideKlas);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideKlas);
    };
  }, [popUpKlas]);

  const handleClickOutsideCM = (event) => {
    if (
      cmRef.current &&
      !cmRef.current.contains(event.target) &&
      !event.target.closest(".centerFirstLi") // або уточни клас, якщо треба
    ) {
      setPopUp(false);
    }
  };

  const handleCMClick = () => {
    setPopUp((prev) => !prev);
  };
  useEffect(() => {
    if (popUp) {
      document.addEventListener("mousedown", handleClickOutsideCM);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideCM);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCM);
    };
  }, [popUp]);
  const handleClickOutsideEur = (event) => {
    if (
      eurRef.current &&
      !eurRef.current.contains(event.target) &&
      !event.target.closest(".centerFirstLiEur")
    ) {
      setPopUpEur(false);
    }
  };
  const handleEurClick = () => {
    setPopUpEur((prev) => !prev);
  };
  useEffect(() => {
    if (popUpEur) {
      document.addEventListener("mousedown", handleClickOutsideEur);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideEur);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideEur);
    };
  }, [popUpEur]);

  const handleMouseEnter = () => {
    setPopUp(true);
  };

  const handleMouseLeave = () => {
    setPopUp(false);
  };

  const handleMouseEnterKlas = () => {
    setPopUpKlas(true);
  };

  const handleMouseLeaveKlas = () => {
    setPopUpKlas(false);
  };

  const handleMouseEnterLibr = () => {
    setPopUpLibr(true);
  };

  const handleMouseLeaveLibr = () => {
    setPopUpLibr(false);
  };

  const handleMouseEnterSuport = () => {
    setPopUpSuport(true);
  };

  const handleMouseLeaveSuport = () => {
    setPopUpSuport(false);
  };

  const handleDropClick = () => {
    if (popUpDrop) {
      setPopUpDrop(false);
    } else {
      setPopUpDrop(true);
    }
  };

  const calculatePopupPosition = () => {
    const buttonPosition = document
      .querySelector(".centerSecondLi")
      .getBoundingClientRect();
    const popupHeight = 250;
    setPopupPosition(buttonPosition.top);
    const element = document.querySelector(".musicWrapOp");
    let needHeight = popupPosition + scrollHeight;
    if (element) {
      element.style.top = scrollHeight;
    }
  };

  const handleClickOutside = (event) => {
    if (
      dropRef.current &&
      !dropRef.current.contains(event.target) &&
      !event.target.closest(".centerSecondLi")
    ) {
      setPopUpDrop(false);
    }
  };

  useEffect(() => {
    if (popUpDrop) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popUpDrop]);

  return (
    <div className="footerWrapperCenter">
      <div className="wrapCenterFirst">
        <ul className="centerFirstUlF">
          <li className="centerFirstLi">
            <Link to="/about" className="centerFirstLi">
              Про видавництво
            </Link>{" "}
          </li>
          <li className="centerFirstLi">
            <Link to="/about" className="centerFirstLi">
              Контакти
            </Link>
          </li>
          <li className="centerFirstLi">
            <Link to="/delivery" className="centerFirstLi">
              Доставка
            </Link>
          </li>
          <li className="centerFirstLi">
            <Link to="/delivery" className="centerFirstLi">
              Самовивіз
            </Link>
          </li>
          <li className="centerFirstLiClub" onClick={handleCMClick}>
            Клуб Майстрів
            {popUp && (
              <PopCH ref={cmRef} onClick={(e) => e.stopPropagation()} />
            )}
          </li>
        </ul>
        <ul className="centerFirstUlS">
          <li className="centerFirstLi">
            <Link to="/delivery" className="centerFirstLi">
              Де побачити наші книги
            </Link>
          </li>
          <li className="centerFirstLi">
            <Link to="/publicOffer" className="centerFirstLi">
              Публічна оферта
            </Link>
          </li>
          <li className="centerFirstLiEur" onClick={handleEurClick}>
            Книги ЧМ в Європі
            {popUpEur && <PopUpEur ref={eurRef} />}
          </li>
        </ul>
      </div>
      <div className="wrapCenterSecond">
        <ul className="centerSecondUlSF">
          <li className="centerSecondLi">
            <Link
              className="centerSecondLi"
              to="mailto:zoryana@chasmaistriv.com.ua"
            >
              Хочете стати нашим партнером? Замовте договір!{" "}
            </Link>
          </li>
          <li className="centerSecondLi">
            <Link to="/opt" className="centerSecondLi">
              Гуртове замовлення робити зручно
            </Link>
          </li>
          <li className="centerSecondLiSpt" onClick={handleKlasClick}>
            СП/Корпоративні/на групу/на клас
            {popUpKlas && (
              <PopSp ref={klasRef} onClick={(e) => e.stopPropagation()} />
            )}
          </li>
        </ul>

        <ul className="centerSecondUlS">
          <li className="centerSecondDrop" onClick={handleDropClick}>
            Дропшипінг
            {popUpDrop && <PopUpDrop ref={dropRef} />}
          </li>
          {/* <li className="centerSecondLi">
            <a
              className="centerSecondLi"
              href="https://drive.google.com/drive/folders/1FVFYuIufuMmrvwhmviehPI7S80dIrhZ3"
              target="_blanck"
            >
              Каталог
            </a>
          </li>
          <li className="centerSecondLi">
            <a
              className="centerSecondLi"
              href="https://docs.google.com/spreadsheets/d/1K4ZJJXsdFtRWL5a14AtTMyWe-YMpnsxTXOJjLO8YHIw/edit#gid=1616448480"
              target="_blanck"
            >
              Завантажити прайс
            </a>
          </li> */}
          <FooterDynamicLinks />
          <li className="centerSecondLiBibil" onClick={handleLibrClick}>
            Підтримка бібліотек і бібліотекарів
            {popUpLibr && (
              <PopUpLibr ref={librRef} onClick={(e) => e.stopPropagation()} />
            )}
          </li>
          <li className="centerSecondLiSuoir" onClick={handleSuportClick}>
            Підтримка продавців-консультантів
            {popUpSuport && (
              <PopUpSuport
                ref={suportRef}
                onClick={(e) => e.stopPropagation()}
              />
            )}
          </li>
        </ul>
      </div>
    </div>
  );
}
